import React, { FunctionComponent } from 'react';
import { addIndex, map, pathOr } from 'ramda';
import withStyles from 'react-jss';
import { Theme } from 'config';

import { ClassProp } from 'helpers/types';
import { renderActiveDates } from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/components/OfferSegmentsTable/components/ActiveSegmentDates/ActiveSegmentDates';
import { Offer } from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/MerchantOffer.types';

const styles = (theme: Theme) => ({
  activeDates: {
    maxHeight: '6rem',
    overflow: 'auto',
    paddingTop: '.78571429em !important',
    paddingLeft: '.78571429em !important',
    paddingBottom: '.78571429em !important',
    '& li:nth-child(even)': {
      backgroundColor: theme.softGray,
    },
  },
  listItem: {
    justifyContent: 'space-between',
    display: 'flex',
  },
  '@global @media only screen and (min-width:1200px)': {
    '.ui.container': {
      width: '82.938rem',
      marginLeft: 'auto!important',
      marginRight: 'auto!important',
    },
  },
});

type Props = {
  classes: ClassProp<ReturnType<typeof styles>>;
  fieldValue: string[];
  record?: Record<string, any>;
  source: Array<number | string>;
  options?: Record<string, unknown>;
};

type DateRange = {
  endDate?: string | Date;
  startDate: string | Date;
};

const mapIndexed = addIndex<DateRange>(map);

const ActiveDates: FunctionComponent<Props> = ({ record, classes }) => {
  const offerSchedule = pathOr(
    [],
    ['offerSchedule'],
    record,
  ) as Array<DateRange>;

  const offer = record as Offer;

  const sortedOffers = offerSchedule.sort((a, b) => {
    if (a.endDate === undefined) {
      return 1;
    }

    if (b.endDate === undefined) {
      return -1;
    }

    return new Date(a.endDate) > new Date(b.endDate) ? -1 : 1;
  });

  const offers = () => {
    if (sortedOffers.length > 0) {
      return sortedOffers;
    }
    // If the offerSchedule array is empty, so will be sortedOffers,
    // so as a fall back, we'll use the offer's offerStartDate and offerEndDate
    return [{ startDate: offer.offerStartDate, endDate: offer.offerEndDate }];
  };

  return (
    <ul style={{ listStyleType: 'none' }} className={classes.activeDates}>
      {mapIndexed((offer, idx) => {
        return (
          <li className={classes.listItem} key={idx}>
            {renderActiveDates(offer.startDate, offer.endDate)}
          </li>
        );
      }, offers())}
    </ul>
  );
};

export default withStyles(styles)(ActiveDates);
